import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _fillInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/fill";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import { makeStyles, Table as MuiTable, TableBody, TableCell, TableHead, TableRow, RaiseColors, Typography } from "components/mui";
import classNames from "classnames";
import useWindowSize from "hooks/useWindowSize";
import * as React from "react";
import Row from "./Rows/Row";
import { InfoIconPopper, LoadingContainer, useTheme } from "componentLibrary";
import TableDataCards from "./TableDataCards";
import { useDeviceDetection } from "hooks/useDeviceDetection";
import FooterRow from "./Rows/FooterRow";
import { stickyColumnShadowStyles } from "./stickyColumnStyles";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function HOITable(_ref) {
  var _useWindowSize$innerW;
  var dataList = _ref.dataList,
    id = _ref.id,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    headers = _ref.headers,
    _ref$onSort = _ref.onSort,
    onSort = _ref$onSort === void 0 ? function () {} : _ref$onSort,
    _ref$reverseSort = _ref.reverseSort,
    reverseSort = _ref$reverseSort === void 0 ? false : _ref$reverseSort,
    _ref$sortBy = _ref.sortBy,
    sortBy = _ref$sortBy === void 0 ? null : _ref$sortBy,
    tableRowClassName = _ref.tableRowClassName,
    _ref$overflowX = _ref.overflowX,
    overflowX = _ref$overflowX === void 0 ? "auto" : _ref$overflowX,
    _ref$overflowY = _ref.overflowY,
    overflowY = _ref$overflowY === void 0 ? "visible" : _ref$overflowY,
    _ref$fixedHeader = _ref.fixedHeader,
    fixedHeader = _ref$fixedHeader === void 0 ? false : _ref$fixedHeader,
    size = _ref.size,
    padding = _ref.padding,
    stickyHeader = _ref.stickyHeader,
    renderTableHead = _ref.renderTableHead,
    renderRow = _ref.renderRow,
    _ref$fixedHeaderHeigh = _ref.fixedHeaderHeight,
    fixedHeaderHeight = _ref$fixedHeaderHeigh === void 0 ? 0 : _ref$fixedHeaderHeigh,
    onRowClick = _ref.onRowClick,
    onRowMouseOver = _ref.onRowMouseOver,
    showPointer = _ref.showPointer,
    classes = _ref.classes,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$loadingCount = _ref.loadingCount,
    loadingCount = _ref$loadingCount === void 0 ? 25 : _ref$loadingCount,
    _ref$disableBorders = _ref.disableBorders,
    disableBorders = _ref$disableBorders === void 0 ? false : _ref$disableBorders,
    _ref$alternatingHighl = _ref.alternatingHighlights,
    alternatingHighlights = _ref$alternatingHighl === void 0 ? false : _ref$alternatingHighl,
    _ref$useCardsOnResize = _ref.useCardsOnResize,
    useCardsOnResize = _ref$useCardsOnResize === void 0 ? false : _ref$useCardsOnResize,
    cardHeader = _ref.cardHeader,
    useCardsMinWidth = _ref.useCardsMinWidth,
    _ref$isLoadingMore = _ref.isLoadingMore,
    isLoadingMore = _ref$isLoadingMore === void 0 ? false : _ref$isLoadingMore,
    renderFooter = _ref.renderFooter,
    footerProps = _ref.footerProps,
    _ref$stickyFirstColum = _ref.stickyFirstColumn,
    stickyFirstColumn = _ref$stickyFirstColum === void 0 ? false : _ref$stickyFirstColum;
  var localClasses = useStyles()();
  var windowSize = (_useWindowSize$innerW = useWindowSize().innerWidth) !== null && _useWindowSize$innerW !== void 0 ? _useWindowSize$innerW : 0;
  var theme = useTheme();
  var device = useDeviceDetection();
  var wrapperRef = React.useRef(null);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isScrolled = _React$useState2[0],
    setIsScrolled = _React$useState2[1];
  // Use 16px border-radius when stickyFirstColumn is enabled (ShadowContainer's default)
  // This ensures the sticky first column respects the container's border-radius
  var borderRadius = stickyFirstColumn ? "16px" : undefined;

  // Track horizontal scroll to show/hide shadow on sticky column
  React.useEffect(function () {
    var wrapper = wrapperRef.current;
    if (!wrapper || !stickyFirstColumn) return;
    var handleScroll = function handleScroll() {
      setIsScrolled(wrapper.scrollLeft > 0);
    };
    wrapper.addEventListener("scroll", handleScroll);
    // Check initial scroll state
    handleScroll();
    return function () {
      return wrapper.removeEventListener("scroll", handleScroll);
    };
  }, [stickyFirstColumn]);
  dataList = dataList || [];
  if (loading) {
    var _context;
    dataList = _fillInstanceProperty(_context = Array(loadingCount)).call(_context, {});
  }
  headers = _filterInstanceProperty(headers).call(headers, function (h) {
    if (h.isVisible && !h.isVisible(windowSize)) {
      return false;
    }
    return true;
  });

  // Default uses 1024px as the breakpoint for switching to cards
  var useCardsWidthMatch = windowSize < (useCardsMinWidth !== null && useCardsMinWidth !== void 0 ? useCardsMinWidth : _valuesInstanceProperty(theme.breakpoints).lg);
  if (useCardsOnResize && useCardsWidthMatch) {
    return /*#__PURE__*/_jsx(TableDataCards, {
      dataList: dataList,
      headers: headers,
      isMobile: device.isMobile,
      cardHeader: cardHeader,
      onCardClick: onRowClick
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    ref: wrapperRef,
    className: classNames(className, _defineProperty({}, localClasses.tableWithfixedTableHeader, fixedHeader)),
    id: id,
    style: {
      overflowY: overflowY,
      overflowX: overflowX,
      borderRadius: stickyFirstColumn ? borderRadius : "inherit"
    },
    children: [/*#__PURE__*/_jsxs(MuiTable, {
      size: size,
      stickyHeader: stickyHeader,
      classes: classes,
      children: [renderTableHead ? renderTableHead({
        headers: headers,
        onSort: onSort,
        reverseSort: reverseSort,
        sortBy: sortBy
      }) : /*#__PURE__*/_jsx(TableHead, {
        style: {
          top: fixedHeaderHeight
        },
        children: /*#__PURE__*/_jsx(TableRow, {
          children: _mapInstanceProperty(headers).call(headers, function (header, index) {
            var isStickyFirstColumn = index === 0 && stickyFirstColumn;

            // Build className based on conditions
            var headerCellClassName = header.headerCellClassName || "";
            if (isStickyFirstColumn) {
              headerCellClassName = isScrolled ? localClasses.stickyHeaderCellPositionedWithShadow : localClasses.stickyHeaderCellPositioned;
            }
            return /*#__PURE__*/_jsx(TableCell, {
              className: headerCellClassName,
              style: _objectSpread({
                width: header.width || "initial",
                minWidth: (header === null || header === void 0 ? void 0 : header.minWidth) || undefined,
                maxWidth: (header === null || header === void 0 ? void 0 : header.maxWidth) || undefined,
                borderBottom: disableBorders ? "none" : "1px solid rgba(224, 224, 224, 1)",
                padding: "16px 12px 12px 12px"
              }, header.tableCellProps || {}),
              children: /*#__PURE__*/_jsx(TableHeader, {
                header: header,
                onSort: onSort,
                reverseSort: reverseSort,
                sortBy: sortBy,
                isMobile: device.isMobile
              })
            }, index);
          })
        })
      }), /*#__PURE__*/_jsx(TableBody, {
        children: _mapInstanceProperty(dataList).call(dataList, function (item, rowIndex) {
          var style = onRowClick ? {
            cursor: "pointer"
          } : {};
          if (showPointer) {
            style = {
              cursor: showPointer(item) ? "pointer" : ""
            };
          }

          // Only mark as last row if there's no footer (footer handles its own border-radius)
          var isLastRow = rowIndex === dataList.length - 1 && !footerProps;
          // First row only needs border-radius if there's no header (header already has it)
          var isFirstRow = rowIndex === 0 && !renderTableHead;
          var tableCellStyle = {
            borderBottom: disableBorders ? "none" : "1px solid rgba(224, 224, 224, 1)",
            backgroundColor: alternatingHighlights && rowIndex % 2 === 0 ? RaiseColors.jllNeutral300 : RaiseColors.neutral100
          };
          var rowProps = {
            key: rowIndex,
            rowIndex: rowIndex,
            item: item,
            headers: headers,
            tableRowClassName: tableRowClassName,
            style: style,
            tableCellStyle: tableCellStyle,
            onRowMouseOver: onRowMouseOver,
            onClick: function onClick(event) {
              return onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick(item, rowIndex, event);
            },
            loading: loading,
            usingTable: true,
            stickyFirstColumn: stickyFirstColumn,
            isLastRow: isLastRow,
            isFirstRow: isFirstRow,
            borderRadius: stickyFirstColumn ? borderRadius : undefined,
            showStickyColumnShadow: isScrolled
          };
          return renderRow ? renderRow(rowProps) : /*#__PURE__*/_jsx(Row, _objectSpread({}, rowProps));
        })
      }), footerProps && (renderFooter ? renderFooter(footerProps) : /*#__PURE__*/_jsx(FooterRow, _objectSpread(_objectSpread({}, footerProps), {}, {
        headers: headers,
        stickyFirstColumn: stickyFirstColumn,
        borderRadius: stickyFirstColumn ? borderRadius : undefined,
        showStickyColumnShadow: isScrolled
      })))]
    }), isLoadingMore && /*#__PURE__*/_jsx(LoadingContainer, {
      iconSize: 16,
      customHeight: "50px",
      paddingTop: "16px"
    })]
  });
}
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      tableWithfixedTableHeader: _defineProperty(_defineProperty({
        marginTop: 24
      }, theme.breakpoints.down("md"), {
        marginTop: 0
      }), "& thead", _defineProperty({
        display: "table",
        position: "fixed",
        background: RaiseColors.white,
        zIndex: 1,
        width: " calc(100% - 336px)",
        "& tr": {
          width: "100%"
        }
      }, theme.breakpoints.down("md"), {
        width: " calc(100% - 48px)"
      })),
      stickyHeaderCell: _objectSpread({
        position: "relative"
      }, stickyColumnShadowStyles),
      stickyHeaderCellPositioned: {
        position: "sticky",
        left: 0,
        zIndex: 3,
        backgroundColor: RaiseColors.white,
        borderTopLeftRadius: "16px"
      },
      stickyHeaderCellPositionedWithShadow: _objectSpread({
        position: "sticky",
        left: 0,
        zIndex: 3,
        backgroundColor: RaiseColors.white,
        borderTopLeftRadius: "16px"
      }, stickyColumnShadowStyles)
    };
  });
};
var TableHeader = function TableHeader(_ref2) {
  var header = _ref2.header,
    onSort = _ref2.onSort,
    sortBy = _ref2.sortBy,
    reverseSort = _ref2.reverseSort,
    isMobile = _ref2.isMobile;
  var HeaderLabel = function HeaderLabel() {
    if (typeof header.label === "function") {
      return header.label({
        onSort: onSort,
        sortBy: sortBy,
        reverseSort: reverseSort
      });
    }
    return /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph_small",
      weight: "medium",
      color: RaiseColors.grayscale900,
      children: header.label
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      alignItems: "center"
    },
    children: [/*#__PURE__*/_jsx(HeaderLabel, {}), header.infoText && /*#__PURE__*/_jsx(InfoIconPopper, {
      title: header.columnName,
      infoText: header.infoText,
      useMobile: isMobile,
      style: {
        marginLeft: "4px"
      }
    })]
  });
};